<template>
  <div class="container-fluid min-vh-100">
    <div class="row d-flex justify-content-center align-items-center min-vh-100">
      <div class="col-12 col-sm-6 col-lg-5 col-xl-3 bg-white">
        <div class="text-center mb-4">
          <img class="w-50" src="../../assets/img/rm-logo.svg" alt="RestMonster logotype">
          <h4 class="text-center mt-2 mb-0">{{ $t('auth.createAccountTitle') }}</h4>
        </div>
        <form @submit.prevent="onSubmit()">
          <div class="mb-3 d-block">
            <label for="userName" class="form-label small text-muted">{{ $t('auth.name') }}</label>
            <input v-model="user.name" class="form-control" type="text" id="userName"
                   :class="v$.user.name.$error ? 'border-danger' : ''">
          </div>
          <div class="mb-3 d-block">
            <label for="userEmail" class="form-label small text-muted">{{ $t('auth.email') }}</label>
            <input v-model.trim="user.email" type="email" class="form-control" id="userEmail" autocomplete="username"
                   :class="v$.user.email.$error ? 'border-danger' : ''">
          </div>
          <div class="mb-3 d-block">
            <label for="userPhone" class="form-label small text-muted">{{ $t('auth.phone') }}</label>
            <input v-model.trim="user.phone" type="text" class="form-control" id="userPhone"
                   v-maska data-maska="+7##########"
                   :class="v$.user.phone.$error ? 'border-danger' : ''">
          </div>
          <div class="mb-3 d-block">
            <div class="d-flex justify-content-between">
              <label for="userPassword" class="form-label small text-muted">{{ $t('auth.password') }}
<!--                <svg width="1rem" height="1rem" class="w-auto ms-auto  position-relative" fill="currentColor"-->
<!--                     data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('auth.passwordDescription')">-->
<!--                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#info-circle"/>-->
<!--                </svg>-->
              </label>
              <div class="form-check form-switch">
                <input v-model="passShow" class="form-check-input" type="checkbox" role="switch" id="flexSwitchShowPass">
                <label class="form-check-label small" for="flexSwitchShowPass">{{ $t('auth.passwordShow') }}</label>
              </div>
            </div>
            <input v-model.trim="user.pass" :type="showHidePass" class="form-control" id="userPassword" autocomplete="current-password"
                   :class="v$.user.pass.$error ? 'border-danger' : ''">
            <div class="small text-muted">{{$t('auth.passwordDescription')}}</div>
          </div>
          <div class="mb-3 pt-2 d-block text-center order-4">
            <button v-if="this.loader" type="button" class="btn btn-outline-dark" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span> {{ $t('auth.btn.loading') }}</span>
            </button>
            <button v-else type="submit" class="btn btn-outline-dark"
            :class="v$.$invalid ? 'disabled': ''">
              {{ $t('auth.btn.create') }}</button>
          </div>
        </form>
        <div class="mb-3 d-block d-flex justify-content-end">
          <router-link to="/signin" class="link-dark">{{ $t('auth.btn.login') }}</router-link>
          <!--                <a class="link-dark disabled" href="#">{{ $t('auth.btn.forgotPassword') }}</a>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = require('@/config')
import router from '../../router'
import { v4 as uuidv4 } from 'uuid'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
import { vMaska } from "maska"
const reqPhoneNumber = helpers.regex(/^\D*7(\D*\d){10}\D*$/)
const reqPassword = helpers.regex(/(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}/g)
import {Tooltip} from "bootstrap";
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
var userPool = new AmazonCognitoIdentity.CognitoUserPool(config.poolData)
var attributeList = [];
var dataName = {
  Name: 'name',
  Value: ''
}
var dataEmail = {
  Name: 'email',
  Value: '',
}
var dataPhoneNumber = {
  Name: 'phone_number',
  Value: '',
}
var dataCustomCompanyId = {
  Name: 'custom:company_id',
  Value: uuidv4()
}
var dataCustomRole = {
  Name: 'custom:role',
  Value: 'company_admin'
}
export default {
  directives: { maska: vMaska },
  name: "CheckIn",
  setup () {
    return { v$: useVuelidate({ $autoDirty: true}) }
  },
  data() {
    return {
      user: {
        name: '',
        email: '',
        phone: '',
        pass: '',
      },
      loader: false,
      errShow: false,
      passShow: false,
    }
  },
  validations() {
    return {
      user: {
        name: { required, minLengthValue: minLength(3) },
        email: { required, email},
        phone: { required, validateFormats: reqPhoneNumber },
        pass: { required, validateFormats: reqPassword }
      }
    }
  },
  computed: {
    showHidePass() {
      return this.passShow ? 'text' : 'password'
    }
  },
  methods: {
    onSubmit() {
      this.loader = true
      // this.authAlert.show = false
      dataName.Value = this.user.name
      dataEmail.Value = this.user.email
      dataPhoneNumber.Value = this.user.phone

      var attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(dataEmail)
      var attributePhoneNumber = new AmazonCognitoIdentity.CognitoUserAttribute(dataPhoneNumber)
      var attributeName = new AmazonCognitoIdentity.CognitoUserAttribute(dataName)
      var attributeCustomCompanyId = new AmazonCognitoIdentity.CognitoUserAttribute(dataCustomCompanyId)
      var attributeCustomRole = new AmazonCognitoIdentity.CognitoUserAttribute(dataCustomRole)

      attributeList.push(attributeEmail)
      attributeList.push(attributePhoneNumber)
      attributeList.push(attributeName)
      attributeList.push(attributeCustomCompanyId)
      attributeList.push(attributeCustomRole)

      userPool.signUp(this.user.email, this.user.pass, attributeList, null, (err, result) => {
        if (err) {
          // this.authAlert.msg = err.message;
          // this.authAlert.show = true;
          this.$store.dispatch('addNewNotice', {text: err.message, error: true})
          this.loader = false;
          return;
        }
        console.log('user name is ' + result.user.getUsername());
        this.loader = false;
        router.push('/CheckInSuccess');
      });

    }
  },
  mounted() {
    // initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  }
}
</script>

<style scoped>

</style>